import { useTranslation } from 'react-i18next';

import { InvoiceState$ } from '@lemoncloud/lemon-billings-api';

export const useGetInvoiceState = () => {
    const { t } = useTranslation();

    const getInvoiceState = (state: InvoiceState$ | undefined) => {
        if (!state) {
            return t('myPage.invoice.state.exception');
        }

        if (state.pay) {
            switch (state.pay) {
                case 'init':
                    return t('myPage.invoice.state.pay.init');
                case 'busy':
                    return t('myPage.invoice.state.pay.busy');
                case 'inPay':
                    return t('myPage.invoice.state.pay.inPay');
                case 'paid':
                    return t('myPage.invoice.state.pay.paid');
                default:
                    return t('myPage.invoice.state.exception');
            }
        }

        switch (state.cancel) {
            case 'init':
                return t('myPage.invoice.state.cancel.init');
            case 'busy':
                return t('myPage.invoice.state.cancel.busy');
            case 'toCancel':
                return t('myPage.invoice.state.cancel.toCancel');
            case 'inCancel':
                return t('myPage.invoice.state.cancel.inCancel');
            case 'canceled':
                return t('myPage.invoice.state.cancel.canceled');
            default:
                return t('myPage.invoice.state.exception');
        }
    };

    return getInvoiceState;
};
